import axios from 'axios';

// Nudging a member from Org Members (Incomplete Profiles): the admin's message
// goes to the member's bell and by email (BE v3AdminMemberNudge). Auth and the
// region go on the request through the app's axios interceptor (App.tsx).

export interface NudgeResult {
  inApp: true;
  /** `skipped`: system emails are switched off, or the member has no address. */
  email: 'sent' | 'skipped' | 'failed';
  /** Nudges this member can still get in the current seven days (three at most). */
  remainingThisWeek: number;
}

/** `orgId` names the org for platform admins only; everyone else's token carries it. */
export const nudgeMember = (userId: string, message: string, orgId?: string): Promise<NudgeResult> =>
  axios
    .post(
      `${process.env.REACT_APP_API}/v3/admin/members/${encodeURIComponent(userId)}/nudge${
        orgId ? `?orgId=${encodeURIComponent(orgId)}` : ''
      }`,
      { message }
    )
    .then((r) => r.data as NudgeResult);
